<template>
  <div>
    <div>
      <Tabs>
        <Tab title="Configure">
          <ConfigureAccreditation class="mt-5"></ConfigureAccreditation>
        </Tab>
        <Tab title="Manage">
          <ManageAccreditation></ManageAccreditation>
        </Tab>
        <Tab title="Documents Builder">
          <DocumentBuilder></DocumentBuilder>
        </Tab>
        <Tab title="Document Templates">
          <DocumentTemplates></DocumentTemplates>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>


<script>
import Tabs from "@/components/commons/tab/Tabs.vue";
import Tab from "@/components/commons/tab/Tab.vue";
import ConfigureAccreditation from "@/pages/business/ConfigureAccreditation.vue";
import ManageAccreditation from "@/pages/business/ManageAccreditation.vue";
import DocumentBuilder from "@/pages/business/DocumentBuilder.vue";
import DocumentTemplates from "@/pages/business/DocumentTemplates.vue";
export default {
  name: "Conformance",
  components: {DocumentTemplates, DocumentBuilder, Tab, Tabs, ConfigureAccreditation, ManageAccreditation},
}
</script>